import React from 'react';

import './AthleteStatus.scss';

export const AthleteStatus = ({ text, contentClass = '', showText = true }) => (
  <div className={`status status-athlete status-${text?.toLowerCase()} ${contentClass}`}>
    <span>{showText ? text : ''}</span>
  </div>
);
